import { axios } from '@Root/API'

export const edit = payload => {
	return axios.put('edit/delivery-roles', payload)
}
